module.exports = __webpack_public_path__ + "assets/img/exampass.3f2c3c58.png";